import React from "react";
import ReactDOM from "react-dom/client";
import "react-quill/dist/quill.snow.css";
import "jsvectormap/dist/css/jsvectormap.css";
import "react-toastify/dist/ReactToastify.css";
import "react-modal-video/css/modal-video.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { AppProvider } from "./context/app";
// import "./ck-editor.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <BrowserRouter>
      <AppProvider>
        <RouteScrollToTop />
        <App />
      </AppProvider>
    </BrowserRouter>
  </>
);

reportWebVitals();
